/**
 * Helpers de formatação BRL para o stub do Pronto Atendimento.
 */

/** Converte número para texto de input (ex.: 150 → "150,00"). */
export function formatBrlInput(value: number): string {
  if (!Number.isFinite(value) || value <= 0) return "";
  return value.toFixed(2).replace(".", ",");
}

/** Interpreta texto BRL (aceita vírgula) como número. */
export function parseBrlInput(raw: string): number {
  const normalized = raw.replace(/\./g, "").replace(",", ".").trim();
  const n = Number(normalized);
  return Number.isFinite(n) ? n : NaN;
}
